import React from "react";
import { Button, Icon } from "@elaniintc/goes-design-system";

interface AddDocumentDividerProps {
  onClick: () => void;
}

const AddDocumentDivider: React.FC<AddDocumentDividerProps> = ({ onClick }) => (
  <div className="flex items-center gap-3 mt-6 mb-15 justify-center px-4">
    <div className="flex-1 h-px border-neutral-quiet border" />
    <Button
      variant="ghost"
      onClick={onClick}
      type="button"
      className="text-body-quiet font-semibold text-sm"
    >
      Añadir documento <Icon type="fas" name="plus" />
    </Button>
    <div className="flex-1 border-neutral-quiet border" />
  </div>
);

export default AddDocumentDivider;
